<template>
  <div class="mask noticemask" v-show="clickis">
    <div class="applogin noticeapplogin">
      <div class="notice_title">{{ title && title != '' ? title : '提醒' }}</div>
      <div
        :class="{ notice_content: true, notice_content_one: success && success == 'notice' }"
        v-html="content"
      ></div>
      <div class="notice_btn ok_btn" v-if="success && success == 'notice'">
        <span class="notice_confirm" @click="confirm()">{{
          oktext && oktext != '' ? oktext : '确认'
        }}</span>
      </div>
      <!-- <div class="notice_btn ok_btn" v-else-if="oktext && oktext!='' && !canceltext" >
         <span class="notice_confirm" @click="confirm()">{{ oktext }}</span>
       </div> -->
      <div class="notice_btn" v-else>
        <span class="notice_cancel" v-if="!hideCancel" @click="cancelbtn()">{{
          canceltext && canceltext != '' ? canceltext : '取消'
        }}</span>
        <span class="notice_confirm" @click="confirm()">{{
          oktext && oktext != '' ? oktext : '好的'
        }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['content', 'success', 'cancel', 'oktext', 'canceltext', 'title', 'hideCancel'],
  data() {
    return {
      clickis: false,
    }
  },
  methods: {
    open() {
      this.clickis = true
    },
    close() {
      this.clickis = false
    },
    cancelbtn() {
      this.clickis = false
      if (this.cancel) {
        this.cancel()
      }
    },
    confirm() {
      this.clickis = false
      if (typeof this.success === 'function') {
        this.success()
      }
    },
  },
}
</script>

<style scoped>
.mask {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 101;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.6);
}
.apploginmask {
  display: flex;
  justify-content: center;
  align-items: center;
}
.applogin {
  width: 90%;
  max-width: 420px;
  background-color: #fff;
  border-radius: 16px;
  padding: 0 30px 30px;
  box-sizing: border-box;
  position: relative;
  user-select: none;
}
.mask_main_content {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  max-width: 750px;
  width: 90%;
  box-sizing: border-box;
}
.noticemask {
  display: flex;
  justify-content: center;
  user-select: none;
  align-items: center;
}
.notice_title {
  text-align: center;
  font-weight: 400;
  font-size: 24px;
  color: #202226;
  line-height: 24px;
  margin: 31px 0 24px;
}
.notice_content {
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 17px;
  color: #626d79;
  text-align: center;
  line-height: 31px;
  margin-bottom: 30px;
}
.notice_content_one {
  text-align: left;
}
.notice_btn {
  display: flex;
  justify-content: center;
  /* padding:0.4rem 0.9375rem 1.25rem; */
}

.notice_btn .notice_cancel {
  margin-right: 20px;
}

.ok_btn {
  justify-content: center;
}
.notice_btn span {
  width: 164px;
  display: block;
  height: 53px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 22px;
  color: #202226;
  line-height: 53px;
  text-align: center;
  border-radius: 10px;
  color: #202226;
  background: #f0f1f1;
  cursor: pointer;
}
.notice_btn .notice_confirm {
  background-color: rgba(7, 194, 97, 1);
  color: #fff;
}
.noticeapplogin {
  width: 84%;
}

@media (max-width: 1024px) {
  .applogin {
    width: 90%;
    background-color: #fff;
    border-radius: 0.16rem;
    padding: 0.44rem;
    box-sizing: border-box;
    position: relative;
    user-select: none;
  }
  .mask_main_content {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    width: 90%;
    box-sizing: border-box;
  }
  .noticemask {
    display: flex;
    justify-content: center;
    user-select: none;
    align-items: center;
    z-index:;
  }
  .notice_title {
    text-align: center;
    font-weight: 400;
    font-size: 0.34rem;
    color: #202226;
    line-height: 0.34rem;
    margin: 0 0 0.39rem;
  }
  .notice_content {
    font-family: Microsoft YaHei;
    font-weight: 400;
    font-size: 0.22rem;
    color: #626d79;
    text-align: center;
    line-height: 0.44rem;
    margin-bottom: 0.44rem;
  }
  .notice_content_one {
    text-align: left;
    font-family: Microsoft YaHei;
    font-weight: 400;
    font-size: 0.22rem;
    color: #202226;
    line-height: 0.44rem;
  }
  .notice_btn {
    display: flex;
    justify-content: center;
    /* padding:0.4rem 0.9375rem 1.25rem; */
  }
  .ok_btn {
    justify-content: center;
  }
  .notice_btn span {
    width: 44%;
    display: block;
    height: 0.75rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    font-size: 0.32rem;
    color: #202226;
    line-height: 0.75rem;
    text-align: center;
    border-radius: 0.1rem;
    cursor: pointer;
  }
  .notice_btn .notice_confirm {
    background-color: rgba(7, 194, 97, 1);
    color: #fff;
  }
  .noticeapplogin {
    width: 84%;
  }
}
</style>
